

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.auth', ['squid']).factory('$AuthApi', function ($Api, $config) {
        return $Api.extend('AuthApi', {
            baseURI: $config.urls.baseUrl,
            uri: '/api/auth',
            postAttempts: 3
        });
    }).factory('$AuthModel', function ($Model, $AuthApi) {

        return $Model.extend('AuthModel', {
            api: new $AuthApi(),

            loggedIn: function loggedIn() {
                return this.logged_in;
            },

            visitorId: function visitorId() {
                return this.visitor_id;
            },

            accessToken: function accessToken() {
                return this.access_token;
            },

            accessTokenPresent: function accessTokenPresent() {
                return this.access_token_present;
            },

            refreshToken: function refreshToken() {
                return this.refresh_token;
            }
        });
    }).factory('$ULoginModel', function ($Model, $Api) {

        return $Model.extend('ULoginModel', {
            api: new $Api({
                uri: '/api/auth/ulogin',
                postAttempts: 1,
                cache: false
            })
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/auth/index.js
 ** module id = 148
 ** module chunks = 1
 **/